<template>
    <div>
        <h3 class="pb-4 text-black text-2xl">
            <span class="font-bold">Highest rated </span>

            <template v-if="manufacturer || model.manufacturer">
                {{ manufacturer ? manufacturer.name : model.manufacturer.name }}
            </template>

            {{ model.name }} tyres
        </h3>

        <Tabs class="mb-4"
              :items="tabItems"
              :activeItem="season"
              @tab-change="season = $event"
        />

        <p class="text-sm mb-4">
            The most popular

            <template v-if="manufacturer || model.manufacturer">
                {{ manufacturer ? manufacturer.name : model.manufacturer.name }}
            </template>

            {{ model.name }} tyres as voted by our users
        </p>

        <Transition name="fade" mode="out-in">
            <div v-if="!loading" class="grid grid-cols-2 xl:grid-cols-3 gap-4">
                <TyreCard v-for="product of localProducts" :product="product" :key="product.id"></TyreCard>

                <p v-if="!localProducts || localProducts.length === 0" class="col-span-full">
                    No tyres found.
                </p>
            </div>

            <div v-else class="grid grid-cols-2 xl:grid-cols-3 gap-4">
                <TyreCardLoader :items="6"></TyreCardLoader>
            </div>
        </Transition>
    </div>
</template>

<script>
import TyreCard from "@/Components/Products/Tyres/TyreCard";
import Tabs from "@/Components/Tabs";
import TyreCardLoader from "@/Components/Loaders/TyreCardLoader";

export default {
    components: {TyreCardLoader, TyreCard, Tabs},
    props: {
        manufacturer: Object,
        model: Object,
        products: Array
    },
    data() {
        return {
            season: null,
            loading: false,
            tabItems: [
                {value: null, text: "All"},
                {value: "Summer", text: "Summer"},
                {value: "All Season", text: "All Season"},
                {value: "Winter", text: "Winter"}
            ],
            localProducts: this.products
        };
    },
    mounted() {
        if (!this.localProducts || this.localProducts.length === 0) {
            this.getProducts();
        }
    },
    watch: {
        season() {
            this.getProducts();
        }
    },
    methods: {
        async getProducts() {
            this.loading = true;

            const response = await axios.get(this.route("models.products.top-rated", this.model), {
                params: {
                    season: this.season
                }
            });

            this.localProducts = response.data;

            this.loading = false;
        }
    }
};
</script>

<style scoped>

</style>
